module.exports = __webpack_public_path__ + "img/uc_carsharing_branco.f85d7670.png";